import { Injectable } from '@angular/core';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'

@Injectable({
  providedIn: 'root',
})
export class PdfGeneratorService {
  imgLogo = 'assets/brand/logo.png';

  generatePdf(content: any[],headers:any[],fileData:any,ordenSalidaNumber:any) {
    const pdf = new jsPDF();
    
    const options = {
      margin: { top: 10 },
      headStyles: { fillColor: [255, 0, 0] },
    };
    

    const columnsToDisplay = ['equipo', 'cantidad','codigo','estado'];

    const body = content.map((obj) => columnsToDisplay.map((key) => this.formatCellValue(key, obj[key])));
    //const body = content.map((obj) => Object.values(obj));

    pdf.addImage(this.imgLogo, "PNG", 10,15, 60, 15);

    pdf.setFontSize(10);
    pdf.text('EXPLORANDES S.A.C.', 200, 15,{align:"right"});
    pdf.text('Calle San Fernando 287 - Miraflores', 200, 20,{align:"right"});
    pdf.text('Lima - Perú', 200, 25,{align:"right"});
    pdf.text('Phone (511) 200-6100', 200, 30,{align:"right"});

    pdf.line(10, 40, 200, 40);

    pdf.setFontSize(13);
    // Texto a centrar
    var pageWidth = pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
    
    let str = `ORDEN DE SALIDA DE EQUIPOS N°${ordenSalidaNumber}`;
    pdf.text(str, pageWidth / 2, 60, {align: 'center'});

/*     pdf.text(`File: ${fileData.fileNumber}`, 10, 60);
    pdf.text(`Ruta: ${fileData.ruta}`, 10, 65);
    pdf.text(`Cantidad Pax: ${fileData.cantPax}`, 10, 70);

    pdf.text(`Guía: ${fileData.guia}`, 200, 60,{align:"right"});
    pdf.text(`Asistente de Guía: ${fileData.asistGuia}`, 200, 65,{align:"right"});
    pdf.text(`Cocinero: ${fileData.cocinero}`, 200, 70,{align:"right"});
    pdf.text(`Asistente de Guía: ${fileData.asistCocina}`, 200, 75,{align:"right"});
    pdf.text(`Jefe de Porters: ${fileData.jefePorter}`, 200, 80,{align:"right"});
    pdf.text(`Jefe de Arrieros: ${fileData.jefeArriero}`, 200, 85,{align:"right"});
    pdf.text(`Total de Porters: ${fileData.totalPorter}`, 200, 90,{align:"right"});
    pdf.text(`Total de Acemilas: ${fileData.totalAcemila}`, 200, 95,{align:"right"});
 */
    const tableData = [
      ["File:", fileData.fileNumber, "Guía:", fileData.guia],
      ["Ruta:", fileData.ruta, "Asistente de Guía:", fileData.asistGuia],
      ["Cantidad Pax:", fileData.cantPax, "Cocinero:", fileData.cocinero],
      ["", "", "Asistente de Cocina:", fileData.asistCocina],
      ["", "", "Jefe de Porters:", fileData.jefePorter],
      ["", "", "Jefe de Arrieros:", fileData.jefeArriero],
      ["", "", "Total de Porters:", fileData.totalPorter],
      ["", "", "Total de Acemilas:", fileData.totalAcemila]
  ];

  const firstTableConfig = {
      startY: 70, // Posición vertical inicial
      margin: { top: 10 }, // Margen superior
      styles: { fontSize: 10 }, // Estilos de texto
      columnWidths: [50, '*', 50, '*'] // Anchos de las columnas
  };
  


  autoTable(pdf,{
    head: [], // Cabecera de la tabla
    body: tableData, 
    ...firstTableConfig

  });

    
    const modifiedBody = body.map(row => {
      const newRow = [...row];
      const codigoIndex = columnsToDisplay.indexOf('codigo');
      const estadoIndex = columnsToDisplay.indexOf('estado');

      if (codigoIndex !== -1) {
          const codigo = newRow[codigoIndex];
          if (typeof codigo === 'string') {
              const codigosSeparados = codigo.split(',');
              newRow[codigoIndex] = codigosSeparados.join('\n');
          }
      }

      if (estadoIndex !== -1) {
          const estado = newRow[estadoIndex];
          if (typeof estado === 'string') {
              const estadosSeparados = estado.split(',');
              newRow[estadoIndex] = estadosSeparados.join('\n');
          }
      }

      return newRow;
  });

  

    autoTable(pdf,{
      startY:140,
      head: [headers], // Cabecera de la tabla
      body: modifiedBody, // Cuerpo de la tabla
      margin: options.margin,
      headStyles:{ fillColor: [233,107, 26] },
      columnStyles:{
        0:{cellWidth:70},
        1:{cellWidth:20},
        2:{cellWidth:40},
        3:{cellWidth:40}
      }
    });

    var base = pdf.output('datauristring'); // base64 string

    console.log("base64 is ", base);

    return base
    // Guardar o mostrar el PDF
    //pdf.save('documento.pdf');
  }

  formatCellValue(key: string, value: any){
    if (key === 'cantidadTotal' && typeof value === 'number') {
      return value.toFixed(2);
    }
    return value.toString(); 
  }
}
